module.exports = __webpack_public_path__ + "static/media/SuccessCases.5e66da79.jpeg";